var backupVoices = {
  Rachel:
    'Microsoft Server Speech Text to Speech Voice (en-US, JennyMultilingualNeural)',
  Domi: 'Microsoft Server Speech Text to Speech Voice (en-US, MonicaNeural)',
  Bella: 'Microsoft Server Speech Text to Speech Voice (en-US, SaraNeural)',
  Antoni: 'Microsoft Server Speech Text to Speech Voice (en-US, GuyNeural)',
  Elli: 'Microsoft Server Speech Text to Speech Voice (en-US, AmberNeural)',
  Josh: 'Microsoft Server Speech Text to Speech Voice (en-US, TonyNeural)',
  Arnold: 'Microsoft Server Speech Text to Speech Voice (en-US, SteffanNeural)',
  Adam: 'Microsoft Server Speech Text to Speech Voice (en-US, RogerNeural)',
  Sam: 'Microsoft Server Speech Text to Speech Voice (en-US, JacobNeural)',
  'Young English British Female 1':
    'Microsoft Server Speech Text to Speech Voice (en-GB, BellaNeural)',
  TheWitcher:
    'Microsoft Server Speech Text to Speech Voice (en-US, ChristopherNeural)',
  'Bruce - Deep American Narrator Voice':
    'Microsoft Server Speech Text to Speech Voice (en-US, DavisNeural)',
};

var backupGoogleVoices = {
  Rachel: 'en-US-Neural2-E===en-US',
  Domi: 'en-US-Neural2-C===en-US',
  Bella: 'en-US-Neural2-F===en-US',
  Antoni: 'en-US-Neural2-D===en-US',
  Elli: 'en-US-Neural2-G===en-US',
  Josh: 'en-US-Neural2-A===en-US',
  Arnold: 'en-US-Standard-H===en-US',
  Adam: 'en-US-Neural2-D===en-US',
  Sam: 'en-US-Neural2-A===en-US',
  'Young English British Female 1': 'en-GB-Standard-A===en-GB',
  TheWitcher: 'en-US-Standard-H===en-US',
  'Bruce - Deep American Narrator Voice': 'en-US-Neural2-H===en-US',
};

const KOKORO_VOICES = [
  'af_nicole','af_bella','af_sarah','af_sky','af_heart','af_alloy','af_aoede',
  'af_jessica','af_kore','af_nova','af_river',
  'am_adam','am_echo','am_eric','am_fenrir','am_liam','am_michael','am_onyx','am_puck','am_santa',
  'bf_emma','bf_isabella','bf_alice','bf_lily',
  'bm_george','bm_lewis','bm_daniel','bm_fable',
];
const DEFAULT_SPEECH_VOICE = 'af_nicole';
const SUPERTONIC_DEFAULT_STEPS = 8;
const SUPERTONIC_MAX_CHUNK_CHARS = 300;
const SUPERTONIC_MAX_CHUNK_CHARS_CJK = 120;
const SUPERTONIC_VOICES = ['F1','F2','F3','F4','F5','M1','M2','M3','M4','M5'];
const SUPERTONIC_LANGUAGES = {
  en: 'English', ko: 'Korean', ja: 'Japanese', ar: 'Arabic', bg: 'Bulgarian',
  cs: 'Czech', da: 'Danish', de: 'German', el: 'Greek', es: 'Spanish',
  et: 'Estonian', fi: 'Finnish', fr: 'French', hi: 'Hindi', hr: 'Croatian',
  hu: 'Hungarian', id: 'Indonesian', it: 'Italian', lt: 'Lithuanian',
  lv: 'Latvian', nl: 'Dutch', pl: 'Polish', pt: 'Portuguese', ro: 'Romanian',
  ru: 'Russian', sk: 'Slovak', sl: 'Slovenian', sv: 'Swedish', tr: 'Turkish',
  uk: 'Ukrainian', vi: 'Vietnamese',
};
const SUPERTONIC_LANGUAGE_ALIASES = {
  'en-us': 'en', 'en-gb': 'en', 'es-419': 'es', 'cmn-hans-cn': 'en',
  zh: 'en', 'zh-cn': 'en', 'zh-tw': 'en', na: 'en',
};

const textGeneratorVoices = {
  'Sarah - Supertonic Female': 'F1',
  'Lily - Supertonic Female': 'F2',
  'Jessica - Supertonic Female': 'F3',
  'Olivia - Supertonic Female': 'F4',
  'Emily - Supertonic Female': 'F5',
  'Alex - Supertonic Male': 'M1',
  'James - Supertonic Male': 'M2',
  'Robert - Supertonic Male': 'M3',
  'Sam - Supertonic Male': 'M4',
  'Daniel - Supertonic Male': 'M5',
  'Nicole - Female': 'af_nicole',
  'Nicole - Female (US)': 'af_nicole',
  'Bella - Female': 'af_bella',
  'Bella - Female (US)': 'af_bella',
  'Sarah - Female': 'af_sarah',
  'Sarah - Female (US)': 'af_sarah',
  'Sky - Female': 'af_sky',
  'Sky - Female (US)': 'af_sky',
  'Heart - Female (US)': 'af_heart',
  'Alloy - Female (US)': 'af_alloy',
  'Aoede - Female (US)': 'af_aoede',
  'Jessica - Female (US)': 'af_jessica',
  'Kore - Female (US)': 'af_kore',
  'Nova - Female (US)': 'af_nova',
  'River - Female (US)': 'af_river',
  'Luna - Female': 'af',
  'Adam - Male': 'am_adam',
  'Adam - Male (US)': 'am_adam',
  'Echo - Male (US)': 'am_echo',
  'Eric - Male (US)': 'am_eric',
  'Fenrir - Male (US)': 'am_fenrir',
  'Liam - Male (US)': 'am_liam',
  'Michael - Male': 'am_michael',
  'Michael - Male (US)': 'am_michael',
  'Onyx - Male (US)': 'am_onyx',
  'Puck - Male (US)': 'am_puck',
  'Santa - Male (US)': 'am_santa',
  'Emma - Female': 'bf_emma',
  'Emma - Female (UK)': 'bf_emma',
  'Isabella - Female': 'bf_isabella',
  'Isabella - Female (UK)': 'bf_isabella',
  'Alice - Female (UK)': 'bf_alice',
  'Lily - Female (UK)': 'bf_lily',
  'George - Male': 'bm_george',
  'George - Male (UK)': 'bm_george',
  'Lewis - Male': 'bm_lewis',
  'Lewis - Male (UK)': 'bm_lewis',
  'Daniel - Male (UK)': 'bm_daniel',
  'Fable - Male (UK)': 'bm_fable',
};

const textGeneratorVoiceValues = {
  F1: 'Sarah - Supertonic Female',
  F2: 'Lily - Supertonic Female',
  F3: 'Jessica - Supertonic Female',
  F4: 'Olivia - Supertonic Female',
  F5: 'Emily - Supertonic Female',
  M1: 'Alex - Supertonic Male',
  M2: 'James - Supertonic Male',
  M3: 'Robert - Supertonic Male',
  M4: 'Sam - Supertonic Male',
  M5: 'Daniel - Supertonic Male',
  af_nicole: 'Nicole - Female',
  af_bella: 'Bella - Female',
  af_sarah: 'Sarah - Female',
  af_sky: 'Sky - Female',
  af_heart: 'Heart - Female',
  af_alloy: 'Alloy - Female',
  af_aoede: 'Aoede - Female',
  af_jessica: 'Jessica - Female',
  af_kore: 'Kore - Female',
  af_nova: 'Nova - Female',
  af_river: 'River - Female',
  af: 'Luna - Female',

  am_adam: 'Adam - Male',
  am_echo: 'Echo - Male',
  am_eric: 'Eric - Male',
  am_fenrir: 'Fenrir - Male',
  am_liam: 'Liam - Male',
  am_michael: 'Michael - Male',
  am_onyx: 'Onyx - Male',
  am_puck: 'Puck - Male',
  am_santa: 'Santa - Male',

  bf_emma: 'Emma - Female',
  bf_isabella: 'Isabella - Female',
  bf_alice: 'Alice - Female',
  bf_lily: 'Lily - Female',
  bm_george: 'George - Male',
  bm_lewis: 'Lewis - Male',
  bm_daniel: 'Daniel - Male',
  bm_fable: 'Fable - Male',
};

var voiceData = {
  voice: DEFAULT_SPEECH_VOICE,
  text: 'Hello, world!',
  volume: 100,
};
const KOKORO_MODEL_ID = 'onnx-community/Kokoro-82M-v1.0-ONNX';
const KOKORO_FIRST_CHUNK_TIMEOUT_MS = 8000;
const KOKORO_MAX_CHUNK_CHARS = 240;
let kokoroTransport = null;
let kokoroTransportType = null;
let kokoroRequestSeq = 0;
let kokoroWarmupTimer = null;
let kokoroWarmupScheduled = false;
const kokoroRequests = new Map();
const SUPERTONIC_LOCAL_BASE_URL = 'https://netwrckstatic.netwrck.com/static/supertonic';
const VOICE_PREVIEW_BASE_URL = 'https://netwrckstatic.netwrck.com/static/voices/preview';
const speechFetchControllers = new Set();
let voicePreviewAudio = null;
const SUPERTONIC_FIRST_CHUNK_TIMEOUT_MS = 10000;
let supertonicTransport = null;
let supertonicTransportType = null;
let supertonicRequestSeq = 0;
let supertonicWarmupTimer = null;
let supertonicWarmupScheduled = false;
const supertonicRequests = new Map();
let sfxVolume = 50;
let isInitialPageLoad = true;
function getTextGeneratorSecret() {
  if (typeof window !== 'undefined') {
    if (typeof window.TEXT_GENERATOR_SECRET === 'string' && window.TEXT_GENERATOR_SECRET) {
      return window.TEXT_GENERATOR_SECRET;
    }
    if (typeof window.TEXTGENERATOR_API_KEY === 'string' && window.TEXTGENERATOR_API_KEY) {
      return window.TEXTGENERATOR_API_KEY;
    }
    if (typeof window.TEXT_GENERATOR_API_KEY === 'string' && window.TEXT_GENERATOR_API_KEY) {
      return window.TEXT_GENERATOR_API_KEY;
    }
  }
  return '';
}

function detectTextLanguage(text) {
  var s = String(text || '');
  var han = 0;
  var kana = 0;
  var hangul = 0;
  for (var i = 0; i < s.length; i++) {
    var code = s.charCodeAt(i);
    if ((code >= 0x4e00 && code <= 0x9fff) || (code >= 0x3400 && code <= 0x4dbf)) han++;
    else if (code >= 0x3040 && code <= 0x30ff) kana++;
    else if (code >= 0xac00 && code <= 0xd7af) hangul++;
  }
  if (kana > 1) return 'ja';
  if (hangul > 2) return 'ko';
  if (han > 1) return 'zh';
  return '';
}

var SPEECH_LANG_TAGS = { zh: 'zh-CN', ja: 'ja-JP', ko: 'ko-KR' };

function pickBrowserVoiceForLang(lang) {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    return null;
  }
  var voices =
    typeof window.speechSynthesis.getVoices === 'function'
      ? window.speechSynthesis.getVoices() || []
      : [];
  if (!voices.length) {
    return null;
  }
  var target = String(lang || '').toLowerCase().replace(/_/g, '-');
  if (!target) {
    return null;
  }
  var base = target.split('-')[0];
  var exact = [];
  var partial = [];
  voices.forEach(function (voice) {
    var vlang = String(voice.lang || '').toLowerCase().replace(/_/g, '-');
    if (vlang === target) exact.push(voice);
    else if (vlang.split('-')[0] === base) partial.push(voice);
  });
  var candidates = exact.length ? exact : partial;
  if (!candidates.length) {
    return null;
  }
  return (
    candidates.find(function (voice) {
      return /google|natural|neural|online|premium|enhanced/i.test(voice.name || '');
    }) || candidates[0]
  );
}

function speakTextInLanguage(text, lang, rate) {
  if (
    typeof window === 'undefined' ||
    !window.speechSynthesis ||
    typeof window.SpeechSynthesisUtterance === 'undefined'
  ) {
    return false;
  }
  var clean = String(text || '').trim();
  if (!clean) {
    return false;
  }
  try {
    window.speechSynthesis.cancel();
  } catch (error) {}
  var utterance = new window.SpeechSynthesisUtterance(clean);
  var voice = pickBrowserVoiceForLang(lang);
  if (voice) {
    utterance.voice = voice;
    utterance.lang = voice.lang;
  } else {
    utterance.lang = lang || 'en-US';
  }
  utterance.rate = Math.min(2, Math.max(0.4, parseFloat(rate) || 0.85));
  window.speechSynthesis.speak(utterance);
  return true;
}

function getBrowserSpeechVoice(requestedVoice) {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    return null;
  }

  const voices =
    typeof window.speechSynthesis.getVoices === 'function'
      ? window.speechSynthesis.getVoices() || []
      : [];
  if (!voices.length) {
    return null;
  }

  const normalized = String(requestedVoice || '').toLowerCase();
  const exactMatch = voices.find(function (voice) {
    return String(voice.name || '').toLowerCase() === normalized;
  });
  if (exactMatch) {
    return exactMatch;
  }
  const wantsFemale =
    /(^a[fb]|^b[fb]|^f\d|female|woman|girl|lady|samantha|jenny|zira|aria|ava|sophia|olivia|emma|elizabeth)/i.test(
      normalized
    );
  const wantsMale =
    /(^am|^bm|^m\d|male|man|boy|guy|david|alex|daniel|tom|john|william|michael|george|liam|mason)/i.test(
      normalized
    );

  const englishVoices = voices.filter((voice) => {
    const lang = String(voice.lang || '').toLowerCase();
    const name = String(voice.name || '').toLowerCase();
    return lang.startsWith('en') || name.includes('english');
  });

  const candidates = englishVoices.length ? englishVoices : voices;
  const femaleRe = /\b(?:female|woman|girl|samantha|jenny|zira|aria|ava|sophia|olivia|emma|elizabeth|victoria|karen|moira|tessa|fiona|kate|serena|susan|allison|kathy)\b/i;
  const maleRe = /\b(?:male|man|boy|guy|david|alex|daniel|tom|john|william|michael|george|liam|mason|fred|rishi|oliver|arthur|gordon|aaron)\b/i;
  // Spread distinct requested voices across the candidate pool deterministically so
  // fallbacks for different presets don't all collapse to candidates[0].
  const pick = function (pool) {
    const list = pool && pool.length ? pool : candidates.length ? candidates : voices;
    if (!list.length) {
      return null;
    }
    let hash = 0;
    for (let i = 0; i < normalized.length; i++) {
      hash = (hash * 31 + normalized.charCodeAt(i)) >>> 0;
    }
    return list[hash % list.length];
  };
  if (wantsFemale) {
    return pick(candidates.filter((v) => !maleRe.test(`${v.name} ${v.lang}`))) || pick(candidates) || voices[0] || null;
  }
  if (wantsMale) {
    return pick(candidates.filter((v) => !femaleRe.test(`${v.name} ${v.lang}`))) || pick(candidates) || voices[0] || null;
  }

  return pick(candidates) || voices[0] || null;
}

function playSoundViaBrowserSpeech(text, voice, captureId) {
  if (
    typeof window === 'undefined' ||
    !window.speechSynthesis ||
    typeof window.SpeechSynthesisUtterance === 'undefined'
  ) {
    return false;
  }

  const chunks = splitSpeechText(text, 180);
  if (!chunks.length) {
    return false;
  }

  const speechSpeed = parseFloat(
    (typeof localStorage !== 'undefined' && localStorage.getItem('speechSpeed')) || '1.0'
  );
  const detectedLang = detectTextLanguage(text);
  let selectedVoice = null;
  if (detectedLang) {
    selectedVoice = pickBrowserVoiceForLang(SPEECH_LANG_TAGS[detectedLang] || detectedLang);
  }
  if (!selectedVoice) {
    selectedVoice = getBrowserSpeechVoice(voice);
  }
  const fallbackLang = detectedLang
    ? SPEECH_LANG_TAGS[detectedLang] || detectedLang
    : 'en-US';
  const queue = chunks.slice();

  try {
    window.speechSynthesis.cancel();
  } catch (error) {}
  stopCharacterSpeech();

  function speakNext() {
    const nextChunk = queue.shift();
    if (!nextChunk) {
      stopCharacterSpeech();
      finalizeReplayCapture(captureId);
      return;
    }

    const utterance = new window.SpeechSynthesisUtterance(nextChunk);
    utterance.rate = Math.min(2.5, Math.max(0.5, speechSpeed || 1.0));
    utterance.pitch = 1.0;
    utterance.volume = 1.0;
    utterance.lang = selectedVoice && selectedVoice.lang ? selectedVoice.lang : fallbackLang;
    if (selectedVoice) {
      utterance.voice = selectedVoice;
    }
    utterance.onstart = function () {
      startCharacterSpeech('', () => 0);
    };
    utterance.onend = speakNext;
    utterance.onerror = function () {
      speakNext();
    };

    try {
      window.speechSynthesis.speak(utterance);
    } catch (error) {
      if (queue.length) {
        speakNext();
      } else {
        stopCharacterSpeech();
        finalizeReplayCapture(captureId);
      }
    }
  }

  speakNext();
  return true;
}

var setVoice = function (voice) {
  voiceData['voice'] = voice;

  if ($('#select-model').length) {
    $('#select-model').val(voice);
  }

  if (typeof Storage !== 'undefined') {
    localStorage.setItem('preferredVoice', voice);
  }
};

$(document).ready(function () {
  let initialVolume = voiceData['volume'];
  if (typeof Storage !== 'undefined') {
    const savedVoice =
      localStorage.getItem('preferredVoice') || DEFAULT_SPEECH_VOICE;
    setVoice(savedVoice);

    const savedVolume = parseInt(localStorage.getItem('preferredVolume'), 10);
    if (!Number.isNaN(savedVolume) && savedVolume >= 0) {
      initialVolume = savedVolume;
    }

    const savedSfxVolume = localStorage.getItem('preferredSfxVolume');
    if (savedSfxVolume) {
      setSfxVolume(parseInt(savedSfxVolume));
      $('#slider-sfx').val(savedSfxVolume);
    }
  }

  setVolume(initialVolume, true);
  $('#slider-seed').val(initialVolume);
});

var setVolume = function (volume, skipPreview) {
  voiceData['volume'] = volume;
  $('#slider-seed-tooltip').html(`Volume: ${volume}`);
  if (volume == 0) {
    $('.sound-icon').html('volume_off');
  } else {
    $('.sound-icon').html('volume_up');
  }

  if (typeof Storage !== 'undefined') {
    localStorage.setItem('preferredVolume', volume);
  }

  if (!isInitialPageLoad && !skipPreview && volume > 0) {
    playVolumePreview();
  }
};

var setSfxVolume = function (volume) {
  sfxVolume = volume;
  if (volume > 0) {
    previousSfxVolume = volume;
  }
  $('#slider-sfx-tooltip').html(`SFX: ${volume}`);
  if (volume == 0) {
    $('.sfx-icon').html('notifications_off');
  } else {
    $('.sfx-icon').html('notifications_active');
  }
  if (typeof Storage !== 'undefined') {
    localStorage.setItem('preferredSfxVolume', volume);
  }

  if (!isInitialPageLoad) {
    playNotification();
  }
};

var getSfxVolume = function () {
  return sfxVolume;
};

let previousSfxVolume = 50;

$(document).on('click', '.sfx-icon-button', function () {
  if (sfxVolume > 0) {
    previousSfxVolume = sfxVolume;
    setSfxVolume(0);
    $('#slider-sfx').val(0);
  } else {
    setSfxVolume(previousSfxVolume);
    $('#slider-sfx').val(previousSfxVolume);
  }
});

$(document).on('keydown', function (e) {
  if (e.key && e.key.toLowerCase() === 'n') {
    $('.sfx-icon-button').click();
  }
});

let previousVolume = 100;

$(document).on('click', '.sound-icon-button', function () {
  if (voiceData['volume'] > 0) {
    previousVolume = voiceData['volume'];
    setVolume(0, true);
    $('#slider-seed').val(0);
  } else {
    setVolume(previousVolume, true);
    $('#slider-seed').val(previousVolume);
  }
});

function isFeatureEnabled(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  const normalized = String(value).trim().toLowerCase();
  if (normalized === '') {
    return defaultValue;
  }
  if (
    normalized === 'false' ||
    normalized === '0' ||
    normalized === 'off' ||
    normalized === 'no' ||
    normalized === 'disabled'
  ) {
    return false;
  }
  return true;
}

function getStaticBaseUrl() {
  if (typeof window === 'undefined') {
    return '/static';
  }
  if (typeof window.STATIC_URL === 'string' && window.STATIC_URL) {
    return window.STATIC_URL.replace(/\/$/, '');
  }
  return '/static';
}

function getWorkerStaticBaseUrl() {
  const staticBase = getStaticBaseUrl();
  if (typeof window === 'undefined' || !window.location) {
    return staticBase;
  }
  try {
    const resolved = new URL(staticBase, window.location.href);
    if (resolved.origin !== window.location.origin) {
      return '/static';
    }
    return resolved.pathname.replace(/\/$/, '') || '/static';
  } catch (e) {
    return '/static';
  }
}

function resolveSpeechVoice(voice) {
  if (textGeneratorVoices[voice]) {
    return textGeneratorVoices[voice];
  }
  const upperVoice = String(voice || '').toUpperCase();
  if (SUPERTONIC_VOICES.indexOf(upperVoice) !== -1) {
    return upperVoice;
  }
  if (KOKORO_VOICES.indexOf(voice) !== -1) {
    return voice;
  }
  return voice;
}

function isSupertonicVoice(voice) {
  return SUPERTONIC_VOICES.indexOf(resolveSpeechVoice(voice)) !== -1;
}

function normalizeSpeechLanguage(language) {
  const normalized = String(language || '').trim().toLowerCase().replace(/_/g, '-');
  if (!normalized) {
    return '';
  }
  if (SUPERTONIC_LANGUAGE_ALIASES[normalized]) {
    return SUPERTONIC_LANGUAGE_ALIASES[normalized];
  }
  const base = normalized.split('-', 1)[0];
  return SUPERTONIC_LANGUAGES[base] ? base : '';
}

function detectSpeechLanguage() {
  if (typeof window !== 'undefined' && window.location && window.location.pathname) {
    const pathLang = normalizeSpeechLanguage(window.location.pathname.split('/').filter(Boolean)[0]);
    if (pathLang) {
      return pathLang;
    }
  }
  if (typeof document !== 'undefined' && document.documentElement) {
    const docLang = normalizeSpeechLanguage(document.documentElement.lang);
    if (docLang) {
      return docLang;
    }
  }
  if (typeof navigator !== 'undefined') {
    const navLangs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || navigator.userLanguage];
    for (const lang of navLangs) {
      const normalized = normalizeSpeechLanguage(lang);
      if (normalized) {
        return normalized;
      }
    }
  }
  return 'en';
}

function getSpeechLanguage() {
  if (typeof localStorage !== 'undefined') {
    const saved = normalizeSpeechLanguage(localStorage.getItem('preferredSpeechLanguage'));
    if (saved) {
      return saved;
    }
  }
  return detectSpeechLanguage();
}

function getSupertonicChunkLimit(language) {
  const lang = normalizeSpeechLanguage(language) || getSpeechLanguage();
  return (lang === 'ko' || lang === 'ja') ? SUPERTONIC_MAX_CHUNK_CHARS_CJK : SUPERTONIC_MAX_CHUNK_CHARS;
}

function getKokoroRuntimeConfig() {
  const hasWebGPU =
    typeof navigator !== 'undefined' &&
    !!navigator.gpu &&
    typeof window !== 'undefined';
  const config = hasWebGPU
    ? { device: 'webgpu', dtype: 'fp32' }
    : { device: 'wasm', dtype: 'q8' };
  if (typeof localStorage !== 'undefined') {
    const dtypeOverride = localStorage.getItem('kokoroDtype');
    const deviceOverride = localStorage.getItem('kokoroDevice');
    if (dtypeOverride) {
      config.dtype = dtypeOverride;
    }
    if (deviceOverride) {
      config.device = deviceOverride;
    }
  }
  return config;
}

function shouldUseKokoroLocal() {
  if (typeof window === 'undefined') {
    return false;
  }
  if (typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent || '')) {
    return false;
  }
  if (
    typeof Worker === 'undefined' &&
    typeof SharedWorker === 'undefined'
  ) {
    return false;
  }
  if (typeof Blob === 'undefined' || typeof URL === 'undefined') {
    return false;
  }
  const kokoroEnabledRaw =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('kokoroTtsEnabled')
      : null;
  if (!isFeatureEnabled(kokoroEnabledRaw, true)) {
    return false;
  }
  return true;
}

function sanitizeSpeechText(text) {
  return String(text || '')
    .replace(/\*\*([^*]*)\*\*/g, '$1')
    .replace(/\*([^*]*)\*/g, '$1')
    .replace(/__([^_]*)__/g, '$1')
    .replace(/_([^_]*)_/g, '$1')
    .replace(/~~([^~]*)~~/g, '$1')
    .replace(/```[\s\S]*?```/g, '')
    .replace(/`([^`]*)`/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/[*~`#|>\-=+\\{}[\]()<>@^]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function isLikelyEnglish(text) {
  var clean = String(text || '').replace(/[\s\d\W]+/g, '');
  if (!clean) return true;
  var ascii = 0;
  var total = clean.length;
  for (var i = 0; i < total; i++) {
    if (clean.charCodeAt(i) < 128) ascii++;
  }
  return (ascii / total) > 0.7;
}

function splitSpeechText(text, maxChars) {
  const limit = Math.max(80, parseInt(maxChars, 10) || KOKORO_MAX_CHUNK_CHARS);
  const normalized = sanitizeSpeechText(text);
  if (!normalized) {
    return [];
  }
  const pieces =
    normalized.match(/[^.!?。！？；]+[.!?。！？；]+|[^.!?。！？；]+$/g) || [normalized];
  const chunks = [];
  let current = '';

  function pushCurrent() {
    const trimmed = current.trim();
    if (trimmed) {
      chunks.push(trimmed);
    }
    current = '';
  }

  function pushLongPiece(piece) {
    if (!/\s/.test(piece) && piece.length > limit) {
      for (let i = 0; i < piece.length; i += limit) {
        chunks.push(piece.slice(i, i + limit));
      }
      return;
    }
    const words = piece.split(/\s+/);
    let line = '';
    for (const word of words) {
      if (!word) {
        continue;
      }
      const candidate = line ? line + ' ' + word : word;
      if (!line) {
        line = word;
        continue;
      }
      if (candidate.length <= limit) {
        line = candidate;
      } else {
        chunks.push(line.trim());
        line = word;
      }
    }
    if (line.trim()) {
      chunks.push(line.trim());
    }
  }

  for (const rawPiece of pieces) {
    const piece = rawPiece.trim();
    if (!piece) {
      continue;
    }
    if (!current) {
      if (piece.length <= limit) {
        current = piece;
      } else {
        pushLongPiece(piece);
      }
      continue;
    }
    const candidate = current + ' ' + piece;
    if (candidate.length <= limit) {
      current = candidate;
    } else {
      pushCurrent();
      if (piece.length <= limit) {
        current = piece;
      } else {
        pushLongPiece(piece);
      }
    }
  }

  pushCurrent();
  return chunks;
}

function enqueueAudioSource(audioUrl, format, options) {
  soundQueue.push(audioUrl);
  soundQueueFormats.push(format || '');
  soundQueueOptions.push(options || {});
  if (soundQueue.length == 1) {
    playNextSound();
  }
}

function enqueueAudioBlob(blob, format, options) {
  options = options || {};
  if (!options.skipReplayCapture && options.captureId) {
    appendReplayCaptureItem(options.captureId, blob, format);
  }
  var capture = options.captureId && replayCaptures.get(options.captureId);
  if (capture && capture.playback === false) {
    return;
  }
  const audioUrl = URL.createObjectURL(blob);
  prepareCharacterSpeechEnvelope(audioUrl, blob);
  enqueueAudioSource(audioUrl, format, options);
}

function revokeAudioUrl(audioUrl) {
  characterSpeechEnvelopes.delete(audioUrl);
  characterSpeechZcrs.delete(audioUrl);
  if (
    typeof URL !== 'undefined' &&
    typeof URL.revokeObjectURL === 'function' &&
    typeof audioUrl === 'string' &&
    audioUrl.indexOf('blob:') === 0
  ) {
    try {
      URL.revokeObjectURL(audioUrl);
    } catch (error) {}
  }
}

function createKokoroTransport() {
  const workerUrl = getWorkerStaticBaseUrl() + '/jsbuild/kokoro-tts-worker.min.js';
  if (typeof SharedWorker !== 'undefined') {
    try {
      const sharedWorker = new SharedWorker(workerUrl, {
        name: 'kokoro-tts',
      });
      sharedWorker.port.start();
      kokoroTransportType = 'shared';
      return {
        postMessage(message) {
          sharedWorker.port.postMessage(message);
        },
        close() {
          sharedWorker.port.close();
        },
        setHandler(handler) {
          sharedWorker.port.onmessage = handler;
          sharedWorker.port.onerror = handler;
        },
      };
    } catch (e) {
      console.warn('SharedWorker failed, falling back to Worker:', e.message);
    }
  }
  if (typeof Worker !== 'undefined') {
    try {
      const worker = new Worker(workerUrl);
      kokoroTransportType = 'worker';
      return {
        postMessage(message) {
          worker.postMessage(message);
        },
        close() {
          worker.terminate();
        },
        setHandler(handler) {
          worker.onmessage = handler;
          worker.onerror = handler;
        },
      };
    } catch (e) {
      console.error('Kokoro worker init failed:', e);
    }
  }
  return null;
}

function ensureKokoroTransport() {
  if (kokoroTransport) {
    return kokoroTransport;
  }
  if (!shouldUseKokoroLocal()) {
    return null;
  }
  kokoroTransport = createKokoroTransport();
  if (!kokoroTransport) {
    return null;
  }
  kokoroTransport.setHandler(handleKokoroMessage);
  const kokoroConfig = getKokoroRuntimeConfig();
  kokoroTransport.postMessage({
    type: 'warmup',
    modelId: KOKORO_MODEL_ID,
    device: kokoroConfig.device,
    dtype: kokoroConfig.dtype,
  });
  return kokoroTransport;
}

function handleKokoroMessage(event) {
  const data = event && event.data ? event.data : event;
  if (!data || !data.requestId) {
    return;
  }
  const request = kokoroRequests.get(data.requestId);
  if (!request) {
    return;
  }
  if (data.type === 'warmup-ready') {
    request.warmed = true;
    return;
  }
  if (data.type === 'chunk') {
    if (request.cancelled) {
      return;
    }
    if (!request.started) {
      request.started = true;
      if (request.timer) {
        clearTimeout(request.timer);
        request.timer = null;
      }
    }
    if (data.audio) {
      enqueueAudioBlob(new Blob([data.audio], { type: 'audio/wav' }), 'wav', {
        captureId: request.captureId,
        onPlaybackError: function () {
          discardReplayCapture(request.captureId);
          playSoundViaRemote(request.text, request.voice, request.eleven, request.captureId);
        },
      });
    }
    return;
  }
  if (data.type === 'done') {
    if (request.timer) {
      clearTimeout(request.timer);
      request.timer = null;
    }
    finalizeReplayCapture(request.captureId);
    kokoroRequests.delete(data.requestId);
    return;
  }
  if (data.type === 'error') {
    if (request.timer) {
      clearTimeout(request.timer);
      request.timer = null;
    }
    kokoroRequests.delete(data.requestId);
    if (!request.fallbackStarted) {
      request.fallbackStarted = true;
      playSoundViaRemote(
        request.text,
        request.voice,
        request.eleven,
        request.captureId
      );
      return;
    }
    discardReplayCapture(request.captureId);
  }
}

function startKokoroPlayback(text, voice, eleven, captureId) {
  const resolvedVoice = resolveSpeechVoice(voice);
  if (KOKORO_VOICES.indexOf(resolvedVoice) === -1) {
    return false;
  }
  const transport = ensureKokoroTransport();
  if (!transport) {
    return false;
  }
  const normalizedText = sanitizeSpeechText(text);
  if (!normalizedText) {
    return false;
  }
  if (!isLikelyEnglish(normalizedText)) {
    return false;
  }
  const requestId = 'kokoro_' + ++kokoroRequestSeq;
  const request = {
    requestId: requestId,
    text: normalizedText,
    voice: resolvedVoice,
    eleven: !!eleven,
    runtime: getKokoroRuntimeConfig(),
    captureId: captureId || null,
    started: false,
    cancelled: false,
    fallbackStarted: false,
    timer: null,
  };
  kokoroRequests.set(requestId, request);
  request.timer = setTimeout(function () {
    const activeRequest = kokoroRequests.get(requestId);
    if (!activeRequest || activeRequest.started || activeRequest.fallbackStarted) {
      return;
    }
    activeRequest.cancelled = true;
    activeRequest.fallbackStarted = true;
    kokoroRequests.delete(requestId);
    try {
      transport.postMessage({
        type: 'cancel',
        requestId: requestId,
      });
    } catch (error) {}
    playSoundViaRemote(normalizedText, voice, eleven, captureId);
  }, KOKORO_FIRST_CHUNK_TIMEOUT_MS);
  transport.postMessage({
    type: 'generate',
    requestId: requestId,
    modelId: KOKORO_MODEL_ID,
    device: request.runtime.device,
    dtype: request.runtime.dtype,
    text: normalizedText,
    voice: request.voice,
    speed: parseFloat(
      (typeof localStorage !== 'undefined' && localStorage.getItem('speechSpeed')) || '1.0'
    ),
    chunkSize: KOKORO_MAX_CHUNK_CHARS,
  });
  return true;
}

function scheduleKokoroWarmup(delayMs) {
  if (!shouldUseKokoroLocal() || kokoroWarmupScheduled) {
    return;
  }
  kokoroWarmupScheduled = true;
  const waitMs = Math.max(0, parseInt(delayMs, 10) || 1500);
  kokoroWarmupTimer = setTimeout(function () {
    kokoroWarmupTimer = null;
    ensureKokoroTransport();
  }, waitMs);
}

function getSupertonicLocalBaseUrl() {
  if (typeof window !== 'undefined' && window.SUPERTONIC_LOCAL_BASE) {
    return String(window.SUPERTONIC_LOCAL_BASE).replace(/\/$/, '');
  }
  return SUPERTONIC_LOCAL_BASE_URL;
}

function shouldUseSupertonicLocal() {
  if (typeof window === 'undefined') {
    return false;
  }
  if (typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent || '')) {
    return false;
  }
  if (typeof Worker === 'undefined' && typeof SharedWorker === 'undefined') {
    return false;
  }
  if (typeof Blob === 'undefined' || typeof URL === 'undefined') {
    return false;
  }
  const platform = String(navigator.platform || '');
  if (
    /iPhone|iPad|iPod/i.test(navigator.userAgent || '') ||
    (platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1)
  ) {
    return false;
  }
  const raw =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('supertonicLocalEnabled')
      : null;
  return isFeatureEnabled(raw, true);
}

function createSupertonicTransport() {
  const workerUrl = getWorkerStaticBaseUrl() + '/jsbuild/supertonic-tts-worker.min.js';
  if (typeof SharedWorker !== 'undefined') {
    try {
      const sharedWorker = new SharedWorker(workerUrl, { name: 'supertonic-tts', type: 'module' });
      sharedWorker.port.start();
      supertonicTransportType = 'shared';
      return {
        postMessage(message) {
          sharedWorker.port.postMessage(message);
        },
        close() {
          sharedWorker.port.close();
        },
        setHandler(handler) {
          sharedWorker.port.onmessage = handler;
          sharedWorker.port.onerror = handler;
        },
      };
    } catch (e) {
      console.warn('Supertonic SharedWorker failed, falling back to Worker:', e.message);
    }
  }
  if (typeof Worker !== 'undefined') {
    try {
      const worker = new Worker(workerUrl, { type: 'module' });
      supertonicTransportType = 'worker';
      return {
        postMessage(message) {
          worker.postMessage(message);
        },
        close() {
          worker.terminate();
        },
        setHandler(handler) {
          worker.onmessage = handler;
          worker.onerror = handler;
        },
      };
    } catch (e) {
      console.error('Supertonic worker init failed:', e);
    }
  }
  return null;
}

function ensureSupertonicTransport() {
  if (supertonicTransport) {
    return supertonicTransport;
  }
  if (!shouldUseSupertonicLocal()) {
    return null;
  }
  supertonicTransport = createSupertonicTransport();
  if (!supertonicTransport) {
    return null;
  }
  supertonicTransport.setHandler(handleSupertonicMessage);
  supertonicTransport.postMessage({
    type: 'warmup',
    baseUrl: getSupertonicLocalBaseUrl(),
    voice: resolveSpeechVoice(voiceData['voice']),
  });
  return supertonicTransport;
}

function handleSupertonicMessage(event) {
  const data = event && event.data ? event.data : event;
  if (!data || !data.requestId) {
    return;
  }
  const request = supertonicRequests.get(data.requestId);
  if (!request) {
    return;
  }
  if (data.type === 'warmup-ready') {
    request.warmed = true;
    return;
  }
  if (data.type === 'chunk') {
    if (request.cancelled) {
      return;
    }
    if (!request.started) {
      request.started = true;
      if (request.timer) {
        clearTimeout(request.timer);
        request.timer = null;
      }
    }
    if (data.audio) {
      enqueueAudioBlob(new Blob([data.audio], { type: 'audio/wav' }), 'wav', {
        captureId: request.captureId,
        onPlaybackError: function () {
          discardReplayCapture(request.captureId);
          playSoundViaRemote(request.text, request.voice, request.eleven, request.captureId);
        },
      });
    }
    return;
  }
  if (data.type === 'done') {
    if (request.timer) {
      clearTimeout(request.timer);
      request.timer = null;
    }
    finalizeReplayCapture(request.captureId);
    supertonicRequests.delete(data.requestId);
    return;
  }
  if (data.type === 'error') {
    if (request.timer) {
      clearTimeout(request.timer);
      request.timer = null;
    }
    supertonicRequests.delete(data.requestId);
    if (!request.fallbackStarted) {
      request.fallbackStarted = true;
      playSoundViaRemote(request.text, request.voice, request.eleven, request.captureId);
      return;
    }
    discardReplayCapture(request.captureId);
  }
}

function startSupertonicPlayback(text, voice, eleven, captureId) {
  const resolvedVoice = resolveSpeechVoice(voice);
  if (SUPERTONIC_VOICES.indexOf(resolvedVoice) === -1) {
    return false;
  }
  if (!shouldUseSupertonicLocal()) {
    return false;
  }
  const transport = ensureSupertonicTransport();
  if (!transport) {
    return false;
  }
  const normalizedText = sanitizeSpeechText(text);
  if (!normalizedText) {
    return false;
  }
  const language = getSpeechLanguage();
  const requestId = 'supertonic_' + ++supertonicRequestSeq;
  const request = {
    requestId: requestId,
    text: normalizedText,
    voice: resolvedVoice,
    eleven: !!eleven,
    captureId: captureId || null,
    started: false,
    cancelled: false,
    fallbackStarted: false,
    timer: null,
  };
  supertonicRequests.set(requestId, request);
  request.timer = setTimeout(function () {
    const activeRequest = supertonicRequests.get(requestId);
    if (!activeRequest || activeRequest.started || activeRequest.fallbackStarted) {
      return;
    }
    activeRequest.cancelled = true;
    activeRequest.fallbackStarted = true;
    supertonicRequests.delete(requestId);
    try {
      transport.postMessage({ type: 'cancel', requestId: requestId });
    } catch (error) {}
    playSoundViaRemote(normalizedText, resolvedVoice, eleven, captureId);
  }, SUPERTONIC_FIRST_CHUNK_TIMEOUT_MS);
  transport.postMessage({
    type: 'generate',
    requestId: requestId,
    baseUrl: getSupertonicLocalBaseUrl(),
    text: normalizedText,
    voice: resolvedVoice,
    language: language,
    steps: SUPERTONIC_DEFAULT_STEPS,
    speed: parseFloat(
      (typeof localStorage !== 'undefined' && localStorage.getItem('speechSpeed')) || '1.0'
    ),
  });
  return true;
}

function scheduleSupertonicWarmup(delayMs) {
  if (!shouldUseSupertonicLocal() || supertonicWarmupScheduled) {
    return;
  }
  supertonicWarmupScheduled = true;
  const waitMs = Math.max(0, parseInt(delayMs, 10) || 1500);
  supertonicWarmupTimer = setTimeout(function () {
    supertonicWarmupTimer = null;
    ensureSupertonicTransport();
  }, waitMs);
}

function playSoundViaRemote(text, voice, eleven, captureId) {
  voice = voice || voiceData['voice'];

  if (textGeneratorVoices[voice]) {
    voice = textGeneratorVoices[voice];
  }
  if (textGeneratorVoiceValues[voice]) {
    const speechSpeed = parseFloat(
      (typeof localStorage !== 'undefined' && localStorage.getItem('speechSpeed')) || '1.0'
    );
    const language = getSpeechLanguage();
    const controller =
      typeof AbortController !== 'undefined' ? new AbortController() : null;
    if (controller) {
      speechFetchControllers.add(controller);
    }
    const releaseController = function () {
      if (controller) {
        speechFetchControllers.delete(controller);
      }
    };

    var speechEndpoint =
      typeof location !== 'undefined' && /\.local$/i.test(location.hostname)
        ? 'https://netwrck.com/api/v1/generate_speech'
        : '/api/v1/generate_speech';
    return fetch(speechEndpoint, {
      method: 'POST',
      signal: controller ? controller.signal : undefined,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: text,
        voice: voice,
        speed: speechSpeed,

        volume: 1.0,
        language: language,
        steps: SUPERTONIC_DEFAULT_STEPS,
        sample_rate: 24000,
      }),
    })
      .then((response) => {
        releaseController();
        if (!response.ok) {
          return response.text().then((body) => {
            const err = new Error(
              `text-generator speech failed: ${response.status} ${response.statusText} ${body.slice(0, 200)}`
            );
            err.status = response.status;
            throw err;
          });
        }
        return response.arrayBuffer();
      })
      .then((arrayBuffer) => {
        const audioBlob = new Blob([arrayBuffer], { type: 'audio/mp3' });
        enqueueAudioBlob(audioBlob, 'mp3', {
          captureId: captureId,
          onPlaybackError: function () {
            discardReplayCapture(captureId);
            playSoundViaBrowserSpeech(text, voice, captureId);
          },
        });
        finalizeReplayCapture(captureId);
      })
      .catch((error) => {
        releaseController();
        if (error && error.name === 'AbortError') {
          discardReplayCapture(captureId);
          return;
        }
        var capture = replayCaptures.get(captureId);
        if (capture && capture.playback === false) {
          discardReplayCapture(captureId);
          console.error('Error:', error);
          return;
        }
        if (playSoundViaBrowserSpeech(text, voice, captureId)) {
          return;
        }
        discardReplayCapture(captureId);
        console.error('Error:', error);
      });
  }

  if (playSoundViaBrowserSpeech(text, voice, captureId)) {
    return Promise.resolve();
  }
  discardReplayCapture(captureId);
  return Promise.resolve();
}

function getClonedVoices() {
  if (typeof localStorage === 'undefined') {
    return [];
  }
  try {
    var parsed = JSON.parse(localStorage.getItem('clonedVoices') || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function getClonedVoice(voice) {
  var id = String(voice || '');
  if (id.indexOf('clone:') !== 0) {
    return null;
  }
  var key = id.slice(6);
  var list = getClonedVoices();
  for (var i = 0; i < list.length; i++) {
    if (list[i] && (list[i].id === key || list[i].name === key)) {
      return list[i];
    }
  }
  return null;
}

function playSoundViaClonedVoice(text, cloned, captureId) {
  if (cloned.previewUrl) {
    return fetch(cloned.previewUrl)
      .then(function (response) { if (!response.ok) throw new Error('voice preview failed: ' + response.status); return response.blob(); })
      .then(function (blob) { enqueueAudioBlob(blob, 'opus', { captureId: captureId }); finalizeReplayCapture(captureId); })
      .catch(function () { return playSoundViaClonedVoiceRemote(text, cloned, captureId); });
  }
  return fetch('/api/voice-clones/' + encodeURIComponent(cloned.id) + '/preview', { method: 'POST', credentials: 'include' })
    .then(function (response) { if (!response.ok) throw new Error('voice preview generation failed: ' + response.status); return response.json(); })
    .then(function (data) {
      cloned.previewUrl = data.preview_url;
      var list = getClonedVoices();
      list.forEach(function (item) { if (item.id === cloned.id) item.previewUrl = cloned.previewUrl; });
      try { localStorage.setItem('clonedVoices', JSON.stringify(list)); } catch (error) {}
      return playSoundViaClonedVoice(text, cloned, captureId);
    })
    .catch(function () { return playSoundViaClonedVoiceRemote(text, cloned, captureId); });
}

function playSoundViaClonedVoiceRemote(text, cloned, captureId) {
  var genText = sanitizeSpeechText(text).slice(0, 1500);
  if (!genText || !cloned || !cloned.refUrl) {
    discardReplayCapture(captureId);
    return;
  }
  return fetch('/fal', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      model_name: 'fal-ai/f5-tts',
      gen_text: genText,
      ref_audio_url: cloned.refUrl,
      model_type: 'F5-TTS',
      remove_silence: true,
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            var err = new Error(data.error || 'voice clone speech failed: ' + response.status);
            err.status = response.status;
            err.redirect = data.redirect;
            throw err;
          });
      }
      return response.json();
    })
    .then(function (data) {
      var url =
        data && data.result && data.result.audio_url && data.result.audio_url.url;
      if (!url) {
        throw new Error('voice clone speech returned no audio');
      }
      return fetch(url)
        .then(function (response) {
          return response.blob();
        })
        .then(function (blob) {
          enqueueAudioBlob(blob, 'wav', { captureId: captureId });
          finalizeReplayCapture(captureId);
        });
    })
    .catch(function (error) {
      console.error('cloned voice playback failed:', error);
      if (error && error.status === 402 && typeof window !== 'undefined') {
        if (typeof window.showSubscribeDialog === 'function') {
          window.showSubscribeDialog();
        }
      }
      var capture = replayCaptures.get(captureId);
      if (capture && capture.playback === false) {
        discardReplayCapture(captureId);
        return;
      }
      if (!playSoundViaBrowserSpeech(text, voiceData['voice'], captureId)) {
        discardReplayCapture(captureId);
      }
    });
}

function startSpeechPipeline(text, voice, eleven, captureId) {
  var resolvedVoice = resolveSpeechVoice(voice);
  var cloned = getClonedVoice(resolvedVoice);
  if (cloned) {
    return playSoundViaClonedVoice(text, cloned, captureId);
  }
  if (startKokoroPlayback(text, voice, eleven, captureId)) {
    return;
  }
  if (startSupertonicPlayback(text, voice, eleven, captureId)) {
    return;
  }
  if (textGeneratorVoiceValues[resolvedVoice] || isSupertonicVoice(resolvedVoice)) {
    return playSoundViaRemote(text, resolvedVoice, eleven, captureId);
  }
  if (playSoundViaBrowserSpeech(text, voice, captureId)) {
    return;
  }
  return playSoundViaRemote(text, voice, eleven, captureId);
}

function playSound(text, voice, eleven) {
  if (!+voiceData['volume']) {
    return;
  }
  const audioEnabledRaw = localStorage.getItem('audioEnabled');
  const audioEnabled = isFeatureEnabled(audioEnabledRaw, true);
  if (!audioEnabled) {
    return;
  }
  const speechGenerationEnabledRaw = localStorage.getItem('speechGenerationEnabled');
  const speechGenerationEnabled = isFeatureEnabled(speechGenerationEnabledRaw, true);
  if (!speechGenerationEnabled) {
    return;
  }
  voice = voice || voiceData['voice'];
  var captureId = createReplayCapture();
  var capture = replayCaptures.get(captureId);
  if (capture) {
    capture.cacheKey = getSpeechCacheKey(text, voice);
  }
  assignReplayCaptureTarget(captureId);
  return startSpeechPipeline(text, voice, eleven, captureId);
}

function speakMessageText(text, chatItem) {
  var clean = String(text || '').trim();
  if (!clean) {
    return;
  }
  if (!+voiceData['volume']) {
    setVolume(previousVolume || 60, true);
    var slider = typeof document !== 'undefined' && document.getElementById('slider-seed');
    if (slider) {
      slider.value = voiceData['volume'];
    }
  }
  resetAudioPlayback();
  try {
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
  } catch (error) {}
  var captureId = createReplayCapture();
  var capture = replayCaptures.get(captureId);
  var cacheKey = getSpeechCacheKey(clean, voiceData['voice']);
  if (capture) {
    capture.cacheKey = cacheKey;
  }
  if (capture && chatItem && chatItem.querySelector) {
    capture.targetElement = chatItem.querySelector('.reactions');
  }
  return loadSpeechCache(cacheKey).then(function (cached) {
    if (cached && cached.items && cached.items.length) {
      cached.items.forEach(function (item) {
        appendReplayCaptureItem(captureId, item.blob, item.format);
        enqueueAudioBlob(item.blob, item.format, { skipReplayCapture: true });
      });
      finalizeReplayCapture(captureId);
      return true;
    }
    return startSpeechPipeline(clean, voiceData['voice'], false, captureId);
  }).catch(function () {
    return startSpeechPipeline(clean, voiceData['voice'], false, captureId);
  });
}

function downloadMessageTextAudio(text, chatItem, button) {
  var clean = String(text || '').trim();
  if (!clean) {
    return false;
  }
  var captureId = createReplayCapture();
  var capture = replayCaptures.get(captureId);
  if (capture) {
    capture.playback = false;
    capture.downloadWhenReady = true;
    capture.actionButton = button || null;
    if (chatItem && chatItem.querySelector) {
      capture.targetElement = chatItem.querySelector('.reactions');
    }
  }
  if (button) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
  }
  var resolvedVoice = resolveSpeechVoice(voiceData['voice']);
  var cloned = getClonedVoice(resolvedVoice);
  if (cloned) {
    playSoundViaClonedVoice(clean, cloned, captureId);
    return true;
  }
  if (!textGeneratorVoiceValues[resolvedVoice] && !isSupertonicVoice(resolvedVoice)) {
    resolvedVoice = DEFAULT_SPEECH_VOICE;
  }
  playSoundViaRemote(clean, resolvedVoice, false, captureId);
  return true;
}

var soundQueue = [];
var soundQueueFormats = [];
var soundQueueOptions = [];
var audioQueue = [];
var howlerCheckInterval = null;
var characterSpeechContext = null;
var characterSpeechEnvelopes = new Map();
var characterSpeechZcrs = new Map();
var characterSpeechTimer = null;
var characterSpeechURL = '';
var replayCaptureSeq = 0;
var replayCaptures = new Map();
var lastReplayCaptureId = null;
var replayButtonObserver = null;

function createReplayCapture() {
  var captureId = 'speech_' + ++replayCaptureSeq + '_' + Date.now();
  replayCaptures.set(captureId, {
    id: captureId,
    items: [],
    finalized: false,
  });
  return captureId;
}

var SPEECH_CACHE_DB = 'netwrck-speech-cache';
var SPEECH_CACHE_STORE = 'audio';
var SPEECH_CACHE_LIMIT = 100 * 1024 * 1024;
var speechCacheDBPromise = null;

function getSpeechCacheKey(text, voice) {
  var value = String(voice || '') + '\n' + getSpeechLanguage() + '\n' + String(text || '').trim();
  var hash = 2166136261;
  for (var i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return 'speech_' + (hash >>> 0).toString(16);
}

function openSpeechCache() {
  if (speechCacheDBPromise || typeof indexedDB === 'undefined') {
    return speechCacheDBPromise;
  }
  speechCacheDBPromise = new Promise(function (resolve, reject) {
    var request = indexedDB.open(SPEECH_CACHE_DB, 1);
    request.onupgradeneeded = function () {
      request.result.createObjectStore(SPEECH_CACHE_STORE, { keyPath: 'key' });
    };
    request.onsuccess = function () { resolve(request.result); };
    request.onerror = function () { reject(request.error); };
  });
  return speechCacheDBPromise;
}

function loadSpeechCache(key) {
  var dbPromise = openSpeechCache();
  if (!dbPromise) {
    return Promise.resolve(null);
  }
  return dbPromise.then(function (db) {
    return new Promise(function (resolve, reject) {
      var request = db.transaction(SPEECH_CACHE_STORE, 'readonly')
        .objectStore(SPEECH_CACHE_STORE).get(key);
      request.onsuccess = function () { resolve(request.result || null); };
      request.onerror = function () { reject(request.error); };
    });
  });
}

function saveSpeechCache(capture) {
  if (!capture || !capture.cacheKey || !capture.items.length) {
    return;
  }
  var size = capture.items.reduce(function (total, item) {
    return total + (item.blob && item.blob.size ? item.blob.size : 0);
  }, 0);
  if (!size || size > SPEECH_CACHE_LIMIT) {
    return;
  }
  var dbPromise = openSpeechCache();
  if (!dbPromise) {
    return;
  }
  dbPromise.then(function (db) {
    return new Promise(function (resolve, reject) {
      var tx = db.transaction(SPEECH_CACHE_STORE, 'readwrite');
      tx.objectStore(SPEECH_CACHE_STORE).put({
        key: capture.cacheKey,
        items: capture.items,
        size: size,
        updatedAt: Date.now(),
      });
      tx.oncomplete = resolve;
      tx.onerror = function () { reject(tx.error); };
    });
  }).then(pruneSpeechCache).catch(function () {});
}

function pruneSpeechCache() {
  var dbPromise = openSpeechCache();
  if (!dbPromise) {
    return Promise.resolve();
  }
  return dbPromise.then(function (db) {
    return new Promise(function (resolve, reject) {
      var request = db.transaction(SPEECH_CACHE_STORE, 'readonly')
        .objectStore(SPEECH_CACHE_STORE).getAll();
      request.onsuccess = function () {
        var records = request.result || [];
        var total = records.reduce(function (sum, record) { return sum + (record.size || 0); }, 0);
        records.sort(function (a, b) { return (a.updatedAt || 0) - (b.updatedAt || 0); });
        var remove = [];
        while (total > SPEECH_CACHE_LIMIT && records.length) {
          var record = records.shift();
          total -= record.size || 0;
          remove.push(record.key);
        }
        if (!remove.length) { resolve(); return; }
        var tx = db.transaction(SPEECH_CACHE_STORE, 'readwrite');
        remove.forEach(function (key) { tx.objectStore(SPEECH_CACHE_STORE).delete(key); });
        tx.oncomplete = resolve;
        tx.onerror = function () { reject(tx.error); };
      };
      request.onerror = function () { reject(request.error); };
    });
  });
}

function getLatestReplayAudioTarget() {
  if (typeof document === 'undefined') {
    return null;
  }
  var targets = document.querySelectorAll(
    '.chat-log__item:not(.chat-log__item--own) .reactions'
  );
  return targets.length ? targets[targets.length - 1] : null;
}

function assignReplayCaptureTarget(captureId) {
  if (!captureId) {
    return;
  }
  var capture = replayCaptures.get(captureId);
  if (!capture) {
    return;
  }
  capture.targetElement = getLatestReplayAudioTarget();
  syncReplayAudioButtons();
}

function appendReplayCaptureItem(captureId, blob, format) {
  if (!captureId || !blob) {
    return;
  }
  var capture = replayCaptures.get(captureId);
  if (!capture) {
    capture = {
      id: captureId,
      items: [],
    };
    replayCaptures.set(captureId, capture);
  }
  capture.items.push({
    blob: blob,
    format: format || '',
  });
}

function discardReplayCapture(captureId) {
  if (!captureId) {
    return;
  }
  var capture = replayCaptures.get(captureId);
  releaseReplayCaptureButton(capture);
  replayCaptures.delete(captureId);
  if (lastReplayCaptureId === captureId) {
    lastReplayCaptureId = null;
  }
  syncReplayAudioButtons();
}

function finalizeReplayCapture(captureId) {
  if (!captureId) {
    return;
  }
  var capture = replayCaptures.get(captureId);
  if (!capture || !capture.items.length) {
    releaseReplayCaptureButton(capture);
    replayCaptures.delete(captureId);
    if (lastReplayCaptureId === captureId) {
      lastReplayCaptureId = null;
    }
    syncReplayAudioButtons();
    return;
  }
  capture.finalized = true;
  lastReplayCaptureId = captureId;
  saveSpeechCache(capture);
  replayCaptures.forEach(function (otherCapture, id) {
    if (id !== captureId && otherCapture.finalized) {
      replayCaptures.delete(id);
    }
  });
  if (capture.downloadWhenReady) {
    downloadReplayCapture(captureId);
    capture.downloadWhenReady = false;
  }
  releaseReplayCaptureButton(capture);
  syncReplayAudioButtons();
}

function releaseReplayCaptureButton(capture) {
  var button = capture && capture.actionButton;
  if (!button) {
    return;
  }
  button.disabled = false;
  button.setAttribute('aria-disabled', 'false');
  button.removeAttribute('aria-busy');
  capture.actionButton = null;
}

function hasReplayAudio() {
  if (!lastReplayCaptureId) {
    return false;
  }
  var capture = replayCaptures.get(lastReplayCaptureId);
  return !!(capture && capture.items && capture.items.length);
}

function getReplayCapture(captureId) {
  var resolvedId = captureId || lastReplayCaptureId;
  if (!resolvedId) {
    return null;
  }
  var capture = replayCaptures.get(resolvedId);
  if (!capture || !capture.items || !capture.items.length) {
    return null;
  }
  return capture;
}

function setReplayActionButtonState(button, enabled) {
  button.disabled = !enabled;
  button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  button.style.opacity = enabled ? '1' : '0.45';
  button.style.pointerEvents = enabled ? 'auto' : 'none';
}

function syncReplayActionTarget(container, capture) {
  if (!container) {
    return;
  }
  if (capture && capture.items && capture.items.length) {
    container.dataset.replayCaptureId = capture.id;
  } else {
    delete container.dataset.replayCaptureId;
  }
  container.querySelectorAll('.message-audio-action').forEach(function (button) {
    if (button.getAttribute('aria-busy') !== 'true') {
      setReplayActionButtonState(button, true);
    }
  });
}

function syncReplayAudioButtons() {
  if (typeof document === 'undefined') {
    return;
  }
  var enabled = hasReplayAudio();
  document.querySelectorAll('#replay-audio-button').forEach(function (button) {
    button.disabled = !enabled;
    button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    button.style.opacity = enabled ? '1' : '0.45';
    button.style.pointerEvents = enabled ? 'auto' : 'none';
  });
  document.querySelectorAll('.reactions').forEach(function (container) {
    syncReplayActionTarget(container, null);
  });
  var capture = getReplayCapture(lastReplayCaptureId);
  if (!capture) {
    return;
  }
  var target = capture.targetElement;
  if (!target || !document.contains(target)) {
    capture.targetElement = null;
    return;
  }
  syncReplayActionTarget(target, capture);
}

function ensureReplayAudioButtonObserver() {
  if (
    replayButtonObserver ||
    typeof MutationObserver === 'undefined' ||
    typeof document === 'undefined' ||
    !document.body
  ) {
    return;
  }
  replayButtonObserver = new MutationObserver(function () {
    syncReplayAudioButtons();
  });
  replayButtonObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function replayLastAudio() {
  return replayAudioCapture(lastReplayCaptureId);
}

function replayAudioCapture(captureId) {
  var capture = getReplayCapture(captureId);
  if (!capture) {
    return false;
  }
  resetAudioPlayback();
  capture.items.forEach(function (item) {
    enqueueAudioBlob(item.blob, item.format, {
      skipReplayCapture: true,
    });
  });
  return true;
}

function getCaptureDownloadInfo(capture) {
  if (!capture || !capture.items || !capture.items.length) {
    return null;
  }
  var firstItem = capture.items[0];
  var format = String(firstItem.format || '').toLowerCase();
  var mimeType = firstItem.blob && firstItem.blob.type ? firstItem.blob.type : '';
  var extension = 'bin';
  if (format === 'mp3' || /audio\/mpeg/.test(mimeType)) {
    extension = 'mp3';
  } else if (format === 'ogg' || /ogg/.test(mimeType)) {
    extension = 'ogg';
  } else if (format === 'wav' || /wav/.test(mimeType)) {
    extension = 'wav';
  } else if (/webm/.test(mimeType)) {
    extension = 'webm';
  }
  return {
    blob:
      capture.items.length === 1
        ? firstItem.blob
        : new Blob(
            capture.items.map(function (item) {
              return item.blob;
            }),
            { type: mimeType || 'application/octet-stream' }
          ),
    extension: extension,
  };
}

function downloadReplayCapture(captureId) {
  var capture = getReplayCapture(captureId);
  if (!capture || typeof document === 'undefined') {
    return false;
  }
  var downloadInfo = getCaptureDownloadInfo(capture);
  if (!downloadInfo) {
    return false;
  }
  var downloadUrl = URL.createObjectURL(downloadInfo.blob);
  var link = document.createElement('a');
  link.href = downloadUrl;
  link.download = 'reply-audio-' + Date.now() + '.' + downloadInfo.extension;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(function () {
    revokeAudioUrl(downloadUrl);
  }, 1000);
  return true;
}

function resolveCaptureIdFromElement(element) {
  var container = element && element.closest ? element.closest('.reactions') : null;
  return container && container.dataset
    ? container.dataset.replayCaptureId || null
    : null;
}

// Check for Howler availability periodically
function checkHowlerAvailability() {
  if (typeof Howl !== 'undefined' && howlerCheckInterval) {
    clearInterval(howlerCheckInterval);
    howlerCheckInterval = null;
  }
}

function emitCharacterSpeech(level, active, zcr) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }
  const detail = { level: Number(level) || 0, active: active === true };
  if (Number.isFinite(Number(zcr))) detail.zcr = Number(zcr);
  window.dispatchEvent(new CustomEvent('netwrck:character-audio', { detail }));
}

function characterSpeechAudioContext() {
  if (characterSpeechContext) {
    return characterSpeechContext;
  }
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) {
    return null;
  }
  try {
    characterSpeechContext = new AudioContextClass();
  } catch (error) {
    return null;
  }
  return characterSpeechContext;
}

function prepareCharacterSpeechEnvelope(audioUrl, blob) {
  const context = characterSpeechAudioContext();
  if (!context || !blob || typeof blob.arrayBuffer !== 'function') {
    return;
  }
  blob.arrayBuffer()
    .then((buffer) => context.decodeAudioData(buffer.slice(0)))
    .then((audio) => {
      const samples = audio.getChannelData(0);
      const frameSize = Math.max(1, Math.round(audio.sampleRate * 0.06));
      const values = [];
      const zcrs = [];
      let peak = 0;
      for (let start = 0; start < samples.length; start += frameSize) {
        const end = Math.min(samples.length, start + frameSize);
        let sum = 0;
        let crossings = 0;
        let last = samples[start];
        for (let index = start; index < end; index += 1) {
          const sample = samples[index];
          sum += sample * sample;
          if (last * sample < 0) crossings += 1;
          last = sample;
        }
        const level = Math.sqrt(sum / Math.max(1, end - start));
        values.push(level);
        zcrs.push(crossings / Math.max(1, end - start));
        peak = Math.max(peak, level);
      }
      if (!peak || !values.length) {
        return;
      }
      const sorted = [...values].sort((left, right) => left - right);
      const floor = sorted[Math.floor((sorted.length - 1) * 0.1)];
      const ceiling = sorted[Math.floor((sorted.length - 1) * 0.95)];
      const range = Math.max(ceiling - floor, peak * 0.08, 0.0001);
      characterSpeechEnvelopes.set(audioUrl, values.map((level) => Math.max(0, Math.min(1, (level - floor) / range))));
      characterSpeechZcrs.set(audioUrl, zcrs);
    })
    .catch(() => {});
}

function stopCharacterSpeech(audioUrl) {
  if (audioUrl && characterSpeechURL && audioUrl !== characterSpeechURL) {
    return;
  }
  if (characterSpeechTimer) {
    clearInterval(characterSpeechTimer);
    characterSpeechTimer = null;
  }
  characterSpeechURL = '';
  emitCharacterSpeech(0, false);
}

function startCharacterSpeech(audioUrl, elapsed) {
  stopCharacterSpeech();
  characterSpeechURL = audioUrl || '';
  const update = () => {
    const seconds = Math.max(0, Number(elapsed?.()) || 0);
    const envelope = characterSpeechEnvelopes.get(audioUrl);
    const zcrs = characterSpeechZcrs.get(audioUrl);
    let level = 0;
    let zcr;
    if (envelope?.length) {
      const index = Math.min(envelope.length - 1, Math.floor(seconds / 0.06));
      level = envelope[index] > 0.035 ? envelope[index] : 0;
      if (zcrs?.length) zcr = zcrs[Math.min(zcrs.length - 1, index)];
    } else {
      level = 0.2 + Math.abs(Math.sin(seconds * 17.3)) * 0.35;
    }
    emitCharacterSpeech(level, level > 0.005, zcr);
  };
  update();
  characterSpeechTimer = setInterval(update, 60);
}

function playNextSound() {
  if (soundQueue.length > 0) {
    let url = soundQueue[0];
    let format = soundQueueFormats[0] || '';
    let options = soundQueueOptions[0] || {};
    const playbackRate = Math.min(2, Math.max(0.5, parseFloat(
      (typeof localStorage !== 'undefined' && localStorage.getItem('speechSpeed')) || '1.0'
    ) || 1));
    let playbackFailed = false;
    const failPlayback = function () {
      if (playbackFailed) return;
      playbackFailed = true;
      stopCharacterSpeech(url);
      const failedUrl = soundQueue.shift();
      soundQueueFormats.shift();
      soundQueueOptions.shift();
      revokeAudioUrl(failedUrl);
      try {
        options.onPlaybackError?.();
      } catch (error) {}
      playNextSound();
    };

    // Check if Howl is available
    if (typeof Howl !== 'undefined') {
      let sound = new Howl({
        src: [url],
        format: format ? [format] : undefined,
        autoplay: true,
        volume: voiceData['volume'] / 100,
        rate: playbackRate,
        onplay: function (id) {
          startCharacterSpeech(url, () => sound.seek(id));
        },
        onend: function () {
          stopCharacterSpeech(url);
          const finishedUrl = soundQueue.shift();
          soundQueueFormats.shift();
          soundQueueOptions.shift();
          revokeAudioUrl(finishedUrl);
          playNextSound();
        },
        onloaderror: failPlayback,
        onplayerror: failPlayback,
      });
      sound.play();
    } else {
      // Start checking for Howler if we haven't already
      if (!howlerCheckInterval) {
        console.warn(
          'Howler.js not loaded yet, starting fallback and monitoring...'
        );
        howlerCheckInterval = setInterval(checkHowlerAvailability, 500);
      }

      // Fallback to regular Audio if Howl isn't loaded yet
      let audio = new Audio(url);
      audio.volume = voiceData['volume'] / 100;
      audio.playbackRate = playbackRate;
      audioQueue.push(audio);
      audio.onplay = function () {
        startCharacterSpeech(url, () => audio.currentTime);
      };
      audio.onended = function () {
        stopCharacterSpeech(url);
        const finishedUrl = soundQueue.shift();
        soundQueueFormats.shift();
        soundQueueOptions.shift();
        revokeAudioUrl(finishedUrl);
        audioQueue = audioQueue.filter(function (item) {
          return item !== audio;
        });
        playNextSound();
      };
      audio.onerror = failPlayback;
      audio.play().catch((e) => {
        console.error('Audio playback failed:', e);
        audioQueue = audioQueue.filter(function (item) {
          return item !== audio;
        });
        failPlayback();
      });
    }
  }
}

$(window).on('load', function () {
  syncReplayAudioButtons();
  ensureReplayAudioButtonObserver();
  if (
    typeof document !== 'undefined' &&
    document.querySelector('textarea, #main-chatbox')
  ) {
    scheduleKokoroWarmup(1500);
  }
  setTimeout(function () {
    isInitialPageLoad = false;
  }, 10000);
});

$(document).ready(function () {
  syncReplayAudioButtons();
  ensureReplayAudioButtonObserver();
});

$(document).on('click', '#replay-audio-button', function (event) {
  event.preventDefault();
  replayLastAudio();
});

$(document).on('click', '.message-audio-action', function (event) {
  event.preventDefault();
  var action = event.currentTarget.dataset.audioAction;
  var chatItem = event.currentTarget.closest('.chat-log__item');
  var messageEl = chatItem && chatItem.querySelector('.chat-log__message');
  if (!messageEl) {
    return;
  }
  if (action === 'replay') {
    speakMessageText(messageEl.textContent, chatItem);
    return;
  }
  if (action === 'download') {
    var captureId = resolveCaptureIdFromElement(event.currentTarget);
    var capture = captureId ? getReplayCapture(captureId) : null;
    if (!capture || capture.items.length !== 1 || !downloadReplayCapture(captureId)) {
      downloadMessageTextAudio(messageEl.textContent, chatItem, event.currentTarget);
    }
  }
});

$(document).on('click', '[data-audio-action="speak"]', function (event) {
  event.preventDefault();
  var chatItem = event.currentTarget.closest('.chat-log__item');
  var messageEl = chatItem && chatItem.querySelector('.chat-log__message');
  if (!messageEl) {
    return;
  }
  speakMessageText(messageEl.textContent, chatItem);
});

function playVolumePreview() {
  const heyAudioPath = '/static/audio/hey.wav';

  const audio = new Audio(heyAudioPath);
  audio.volume = voiceData['volume'] / 100;

  audio.addEventListener('canplaythrough', function () {
    audio.play().catch((e) => {

      if (typeof window.playSound === 'function') {
        window.playSound('Hey', voiceData['voice']);
      } else {
        playSound('Hey', voiceData['voice']);
      }
    });
  });

  audio.addEventListener('error', function () {
    if (typeof window.playSound === 'function') {
      window.playSound('Hey', voiceData['voice']);
    } else {
      playSound('Hey', voiceData['voice']);
    }
  });

  audio.load();
}

let notificationAudioContext = null;
let audioContextInitialized = false;

function initializeAudioContext() {
  if (
    !audioContextInitialized &&
    (window.AudioContext || window.webkitAudioContext)
  ) {
    try {
      notificationAudioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      audioContextInitialized = true;
    } catch (e) {
      console.error('Failed to initialize audio context:', e);
    }
  }
}

$(document).one('click touchstart', function () {
  initializeAudioContext();
});

function playNotification() {
  if (!sfxVolume || document.hidden || isInitialPageLoad) {
    return;
  }

  if (!audioContextInitialized) {
    initializeAudioContext();
  }

  if (!notificationAudioContext) {
    return;
  }

  try {
    const ctx = notificationAudioContext;

    const osc1 = ctx.createOscillator();
    const osc2 = ctx.createOscillator();
    const osc3 = ctx.createOscillator();

    const gain1 = ctx.createGain();
    const gain2 = ctx.createGain();
    const gain3 = ctx.createGain();
    const masterGain = ctx.createGain();

    osc1.type = 'sine';
    osc1.frequency.value = 261.63;

    osc2.type = 'sine';
    osc2.frequency.value = 329.63;

    osc3.type = 'triangle';
    osc3.frequency.value = 392.0;

    gain1.gain.value = 0.3;
    gain2.gain.value = 0.2;
    gain3.gain.value = 0.15;

    masterGain.gain.value = sfxVolume / 100;

    osc1.connect(gain1);
    osc2.connect(gain2);
    osc3.connect(gain3);

    gain1.connect(masterGain);
    gain2.connect(masterGain);
    gain3.connect(masterGain);
    masterGain.connect(ctx.destination);

    const now = ctx.currentTime;
    masterGain.gain.setValueAtTime(0, now);
    masterGain.gain.linearRampToValueAtTime(sfxVolume / 100, now + 0.1);
    masterGain.gain.linearRampToValueAtTime(0, now + 0.8);

    osc1.start(now);
    osc2.start(now);
    osc3.start(now);

    setTimeout(function () {
      osc1.stop();
      osc2.stop();
      osc3.stop();
    }, 900);
  } catch (e) {
    console.error('playNotification error', e);
  }
}

function cancelWorkerRequests(requests, transport) {
  requests.forEach(function (request, requestId) {
    request.cancelled = true;
    request.fallbackStarted = true;
    if (request.timer) {
      clearTimeout(request.timer);
      request.timer = null;
    }
    if (transport) {
      try {
        transport.postMessage({ type: 'cancel', requestId: requestId });
      } catch (error) {}
    }
    discardReplayCapture(request.captureId);
  });
  requests.clear();
}

function cancelPendingSpeech() {
  cancelWorkerRequests(kokoroRequests, kokoroTransport);
  cancelWorkerRequests(supertonicRequests, supertonicTransport);
  speechFetchControllers.forEach(function (controller) {
    try {
      controller.abort();
    } catch (error) {}
  });
  speechFetchControllers.clear();
}

function stopVoicePreview() {
  if (!voicePreviewAudio) {
    return;
  }
  try {
    voicePreviewAudio.pause();
    voicePreviewAudio.currentTime = 0;
  } catch (error) {}
  voicePreviewAudio = null;
}

function voicePreviewURL(voice) {
  var resolved = resolveSpeechVoice(voice);
  var cloned = getClonedVoice(resolved);
  if (cloned) {
    return cloned.previewUrl || '';
  }
  if (KOKORO_VOICES.indexOf(resolved) !== -1) {
    return VOICE_PREVIEW_BASE_URL + '/' + resolved + '.opus';
  }
  if (SUPERTONIC_VOICES.indexOf(resolved) !== -1) {
    return VOICE_PREVIEW_BASE_URL + '/supertonic_' + resolved + '.opus';
  }
  return '';
}

function playVoicePreview(voice) {
  var url = voicePreviewURL(voice || voiceData['voice']);
  resetAudioPlayback();
  if (!url) {
    return Promise.resolve(false);
  }
  return new Promise(function (resolve) {
    var audio = new Audio(url);
    audio.preload = 'auto';
    audio.volume = Math.max(0, Math.min(1, (+voiceData['volume'] || 60) / 100));
    audio.playbackRate = Math.min(2, Math.max(0.5, parseFloat(
      (typeof localStorage !== 'undefined' && localStorage.getItem('speechSpeed')) || '1.0'
    ) || 1));
    voicePreviewAudio = audio;
    audio.addEventListener('error', function () {
      if (voicePreviewAudio === audio) {
        voicePreviewAudio = null;
      }
      resolve(false);
    });
    audio.addEventListener('playing', function () {
      resolve(true);
    });
    audio.addEventListener('ended', function () {
      if (voicePreviewAudio === audio) {
        voicePreviewAudio = null;
      }
    });
    var started = audio.play();
    if (started && typeof started.catch === 'function') {
      started.catch(function () {
        resolve(false);
      });
    }
  });
}

function resetAudioPlayback() {
  cancelPendingSpeech();
  stopVoicePreview();
  stopCharacterSpeech();
  soundQueue.forEach(function (url) {
    revokeAudioUrl(url);
  });
  soundQueue = [];
  soundQueueFormats = [];
  soundQueueOptions = [];
  if (typeof Howler !== 'undefined' && Howler.stop) {
    Howler.stop();
  }
  if (!audioQueue.length) {
    return;
  }
  audioQueue.forEach(function (audio) {
    try {
      audio.pause();
      audio.currentTime = 0;
    } catch (err) {}
  });
  audioQueue = [];
}

// Expose audio controls to global scope for cross-module access
if (typeof window !== 'undefined') {
  window.playSound = window.playSound || playSound;
  window.playNotification = window.playNotification || playNotification;
  window.setVoice = window.setVoice || setVoice;
  window.setVolume = window.setVolume || setVolume;
  window.setSfxVolume = window.setSfxVolume || setSfxVolume;
  window.getSfxVolume = window.getSfxVolume || getSfxVolume;
  window.backupVoices = window.backupVoices || backupVoices;
  window.backupGoogleVoices = window.backupGoogleVoices || backupGoogleVoices;
  window.voiceData = window.voiceData || voiceData;
  window.SUPERTONIC_SPEECH_LIMITS = window.SUPERTONIC_SPEECH_LIMITS || {
    defaultChunkChars: SUPERTONIC_MAX_CHUNK_CHARS,
    cjkChunkChars: SUPERTONIC_MAX_CHUNK_CHARS_CJK,
    approximateDefaultWords: '45-60',
    steps: SUPERTONIC_DEFAULT_STEPS,
    voices: SUPERTONIC_VOICES.slice(),
    languages: Object.assign({}, SUPERTONIC_LANGUAGES),
  };
  window.resetAudioPlayback =
    window.resetAudioPlayback || resetAudioPlayback;
  window.playVoicePreview = window.playVoicePreview || playVoicePreview;
  window.voicePreviewURL = window.voicePreviewURL || voicePreviewURL;
  window.stopVoicePreview = window.stopVoicePreview || stopVoicePreview;
  window.replayLastAudio = window.replayLastAudio || replayLastAudio;
  window.downloadReplayCapture =
    window.downloadReplayCapture || downloadReplayCapture;
  window.syncReplayAudioButtons =
    window.syncReplayAudioButtons || syncReplayAudioButtons;
  window.splitSpeechText = window.splitSpeechText || splitSpeechText;
  window.speakMessageText = window.speakMessageText || speakMessageText;
  window.downloadMessageTextAudio =
    window.downloadMessageTextAudio || downloadMessageTextAudio;
  window.speakTextInLanguage = window.speakTextInLanguage || speakTextInLanguage;
  window.detectTextLanguage = window.detectTextLanguage || detectTextLanguage;
  window.pickBrowserVoiceForLang = window.pickBrowserVoiceForLang || pickBrowserVoiceForLang;
  window.getClonedVoices = window.getClonedVoices || getClonedVoices;
  window.NETWRCK_VOICE_CATALOG = window.NETWRCK_VOICE_CATALOG || {
    kokoro: KOKORO_VOICES.slice(),
    supertonic: SUPERTONIC_VOICES.slice(),
    labels: Object.assign({}, textGeneratorVoiceValues),
  };
  window.kokoroWarmup = window.kokoroWarmup || function () {
    return ensureKokoroTransport();
  };
  window.supertonicWarmup = window.supertonicWarmup || function () {
    return ensureSupertonicTransport();
  };
  window.shouldUseSupertonicLocal = window.shouldUseSupertonicLocal || shouldUseSupertonicLocal;

  if (typeof document !== 'undefined' && !window.__kokoroTypingWarmupInstalled) {
    window.__kokoroTypingWarmupInstalled = true;
    const warmupOnTextareaInteraction = function (event) {
      if (!shouldUseKokoroLocal()) {
        return;
      }
      const target = event && event.target;
      if (!target || !target.tagName || target.tagName.toLowerCase() !== 'textarea') {
        return;
      }
      if (event.metaKey || event.ctrlKey || event.altKey) {
        return;
      }
      ensureKokoroTransport();
    };
    document.addEventListener('focusin', warmupOnTextareaInteraction, true);
    document.addEventListener('keydown', warmupOnTextareaInteraction, true);
  }
}
